module.exports = __webpack_public_path__ + "img/E10.8cbfbbf0.svg";